import { z } from "zod";

const loginSchema = z.object({
	email: z
		.string({ message: "O email não pode ser vazio!" })
		.email()
		.max(55, "O email é muito grande, tente novamente!"),
	password: z
		.string({ message: "A senha não pode ser vazia!" })
		.min(6, "O senha é muito pequena, tente novamente!")
		.max(120, "O senha é muito grande, tente novamente!"),
});

export type iLoginData = z.infer<typeof loginSchema>;

export { loginSchema };
